<template>
  <div class="navbar-container main-menu-content">
    <horizontal-nav-menu-items :items="navMenuItems" />
  </div>
</template>

<script>
import staticNavMenuItems from '@/navigation/horizontal'
import { computed } from 'vue'
import { useStore } from 'vuex'
import HorizontalNavMenuItems from './components/horizontal-nav-menu-items/HorizontalNavMenuItems.vue'

export default {
  components: {
    HorizontalNavMenuItems,
  },
  setup() {
    const store = useStore()

    const navMenuItems = computed(() => {
      const items = [...staticNavMenuItems]
      const moduleGroups = store.getters['modulesRegistry/navGroups'] || []
      if (!moduleGroups.length) {
        return items
      }

      const profileIdx = items.findIndex((item) => item.route === 'profile')
      if (profileIdx >= 0) {
        items.splice(profileIdx, 0, ...moduleGroups)
      } else {
        items.push(...moduleGroups)
      }

      return items
    })

    return {
      navMenuItems,
    }
  },
}
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/horizontal-menu.scss";
</style>
